import { useFrame, extend } from "@react-three/fiber";
import SpriteText from "three-spritetext";
import { OrbitControls } from "@react-three/drei";
import { useRef } from "react";
extend({ SpriteText });

const Skills = () => {
  const getPos = (k) => {
    let a = Math.random();
    let b = Math.random();
    return b > 0.5 ? a * k : a * -1 * k;
  };
  const skills = [
    "HTML",
    "CSS",
    "JavaScript",
    "TypeScript",
    "Angular",
    "React",
    "React Native",
    "Redux",
    "ThreeJs",
    "Nodejs",
    "Express",
    "NPM",
    "MySQL",
    "PostgreSQL",
    "MongoDB",
    "GraphQL",
    "Git",
    "AWS",
    "JSON",
  ];
  const g = useRef();
  useFrame(() => {
    g.current.rotation.x += 0.004;
    g.current.rotation.y += 0.004;
    g.current.rotation.z += 0.001;
  });
  return (
    <>
      <OrbitControls enablePan={false} enableZoom={false} />
      <pointLight position={[-2, 2, 2]} args={["#fff", 0.3]} />
      <group ref={g} position={[0, 0, 0]} scale={0.1}>
        {skills.map((a, i) => {
          return (
            <spriteText
              text={a}
              key={i}
              fontSize={90}
              position={[getPos(80), getPos(80), getPos(80)]}
              fontFace={"'Dank Mono','Fira Code','Roboto Mono', monospace"}
              color={i % 2 === 0 ? "#667DFF" : "#E06D06"}
            />
          );
        })}
      </group>
    </>
  );
};

export default Skills;
